import { PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE } from '@/lib/constants';
import * as yup from 'yup';

export const newPasswordSchema = yup.object({
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE),
});
